import React from 'react'
import { useMap } from '../hooks'

const PrintMap = ({ children, id }) => {
  id = id || 'print-map'
  useMap(id)

  const kids = React.Children.map(children, (child) => {
    return React.cloneElement(child, { mapId: id })
  })

  return (
    <div id={`mym-map-${id}`} className="print--map">
      {kids}
    </div>
  )
}

export default PrintMap
